/* This is a mst-gql generated file, don't modify it manually */
/* eslint-disable */
/* tslint:disable */
// @ts-nocheck

import { types } from 'mobx-state-tree'
import { QueryBuilder } from 'mst-gql'
import { ModelBase } from './ModelBase'
import { RootStoreType } from './index'

/**
 * PlayerInformationBase
 * auto generated base class for the model PlayerInformationModel.
 */
export const PlayerInformationModelBase = ModelBase.named('PlayerInformation')
  .props({
    __typename: types.optional(types.literal('PlayerInformation'), 'PlayerInformation'),
    lastActive: types.union(types.undefined, types.frozen()),
    memberSince: types.union(types.undefined, types.frozen())
  })
  .views((self) => ({
    get store() {
      return self.__getStore<RootStoreType>()
    }
  }))

export class PlayerInformationModelSelector extends QueryBuilder {
  get lastActive() {
    return this.__attr('lastActive')
  }
  get memberSince() {
    return this.__attr('memberSince')
  }
}
export function selectFromPlayerInformation() {
  return new PlayerInformationModelSelector()
}

export const playerInformationModelPrimitives = selectFromPlayerInformation().lastActive.memberSince
